import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    File as FileModel,
    CreateFileDocument,
    UpdateFileDocument,
    RemoveFileMutationVariables,
    RemoveFileDocument
} from "@/endpoints/rutsolve/gql/generated/graphql"
import {
    CreateFileMutationVariables,
    UpdateFileMutationVariables
} from "@/endpoints/rutsolve/gql/generated/types"

export class File extends Client {
    constructor() {
        super()
    }

    public async create(input: FileModel) {
        try {
            const variables: CreateFileMutationVariables = {
                input: {
                    data: input.data,
                    description: input.description,
                    extension: input.extension,
                    name: input.name,
                    priority: input.priority,
                    relationID: input.relationID,
                    relationType: input.relationType,
                    type: input.type,
                }
            }
            await this.client.request(CreateFileDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async update(input: FileModel) {
        try {
            const variables: UpdateFileMutationVariables = {
                input: {
                    data: input.data,
                    description: input.description,
                    extension: input.extension,
                    id: input.id,
                    name: input.name,
                    priority: input.priority,
                    type: input.type,
                }
            }
            await this.client.request(UpdateFileDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async remove(fileID: string) {
        try {
            const variables: RemoveFileMutationVariables = {
                fileID: fileID
            }
            await this.client.request(RemoveFileDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }
}
